module.exports = __webpack_public_path__ + "vrsafety/static/media/circle_frame.448ebeb3.png";